import { registerComponent } from '@gig/magic-common';
import AccountClosureSuccessComponent from './success.vue.js';

var AccountClosureSuccess = registerComponent(AccountClosureSuccessComponent);

export { AccountClosureSuccess };
